import _typeof from 'babel-runtime/helpers/typeof';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';
import { isUndef, isDef, LimitationMessageQueue } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

var NAMESPACE = 'td';

var Message = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "td-message", class: 'td-message--' + _vm.type }, [_vm._t("icon", [_c('td-icon', { attrs: { "type": _vm.type } })]), _vm._v(" "), _c('span', { staticClass: "td-message__text" }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2)], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-message',

  components: {
    TdIcon: Icon
  },

  props: {
    message: String,
    type: String,
    duration: {
      type: Number,
      default: 3000,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    position: {
      type: String,
      default: 'top'
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    var cover = document.querySelector('.td-cover.td-cover--message.is-' + this.position);

    if (isUndef(cover)) {
      cover = document.createElement('div');
      cover.className = 'td-cover td-cover--message is-' + this.position;
      document.body.appendChild(cover);
    }

    cover.appendChild(this.$el);
  },
  destroyed: function destroyed() {
    if (isDef(this.$el.parentNode)) {
      window.clearTimeout(this.timer);
      this.timer = null;
      this.$el.parentNode.removeChild(this.$el);
    }
  },


  methods: {
    show: function show() {
      if (!this.visible) {
        this.visible = true;
        this.$emit('show');
      }

      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.duration) {
        this.timer = setTimeout(this.hide, this.duration);
      }
    },
    hide: function hide() {
      if (this.visible) {
        this.visible = false;
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.$emit('hide');
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
};

var messageInstanceMap = {};
Message.install = function (Vue) {
  Vue.prototype.$message = function (options) {
    var MessageConstructor = Vue.extend(Message);
    var propsData = {};
    var slots = options.slots;

    if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
      for (var prop in options) {
        if (prop in Message.props) {
          propsData[prop] = options[prop];
        }
      }
    }

    var vm = new MessageConstructor({
      el: document.body.appendChild(document.createElement('div')),
      propsData: propsData
    });
    if (options.id) {
      var id = options.id;
      if (!messageInstanceMap[id]) {
        messageInstanceMap[id] = new LimitationMessageQueue(options);
      }
      if (!messageInstanceMap[id].push(vm)) {
        vm.$destroy();
      }
    }
    if (slots) {
      for (var s in slots) {
        vm.$slots[s] = slots[s];
      }
    }

    vm.show();
    // 如果有message queue 需要再清空的时候清空一下
    vm.$on('hide', function () {
      if (options.id) {
        var _id = options.id;
        if (messageInstanceMap[_id]) {
          var length = messageInstanceMap[_id].clear();
          if (!length) {
            delete messageInstanceMap[_id];
          }
        }
      }
      vm.$destroy();
    });

    return vm;
  };['success', 'warning', 'error'].forEach(function (type) {
    Vue.prototype.$message[type] = function (message) {
      Vue.prototype.$message({ type: type, position: 'middle', message: message });
    };
  });
  Vue.component(Message.name, Message);
};

export default Message;
